import { collection, deleteDoc, deleteField, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../firebase";

/**
 * Separates a charity from a bar (the bar switched charities, or the
 * partnership ended). Removes:
 *   - the charity link on the bar
 *   - the gaming info the charity entered (charity name, license, boxes...)
 *   - events that charity posted at this bar (bingo, raffles, etc.)
 * The bar, its owner, and everything the owner posted stay as they are.
 * Returns how many events were removed.
 */
export async function unlinkCharity(bar) {
  const charityUid = bar.charityId;
  await updateDoc(doc(db, "bars", bar.id), { charityId: "", gaming: deleteField() });

  let removed = 0;
  if (charityUid) {
    const snap = await getDocs(query(collection(db, "events"), where("barId", "==", bar.id)));
    for (const d of snap.docs) {
      if (d.data().createdBy === charityUid) {
        await deleteDoc(d.ref);
        removed++;
      }
    }
  }
  return removed;
}
